export default "__VITE_ASSET__CflUOuxW__"